import styled, { css } from 'styled-components';
import { Card, Flex, IconChevronRightCircle, mediaMixin, spaceMixin, token } from '@zillow/constellation';

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: row;
  align-items: center;

  height: 94px;
  padding: 16px;
  margin-bottom: 0;
  cursor: pointer;

  ${mediaMixin(
    'lg',
    css`
      margin-left: 0;
      margin-right: 0;
      margin-bottom: ${spaceMixin('sm')};
    `,
  )}
`;

export const StyledLabel = styled(Flex)`
  flex-grow: 1;
`;

export const StyledIconChevronRightCircle = styled(IconChevronRightCircle)`
  color: ${token('colors.brand')};
  float: right;
  position: relative;
`;
